// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsOfService_root__YB9-b","lastUpdated":"TermsOfService_lastUpdated__13BAl","disc":"TermsOfService_disc__1r2zc"};